import { useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type {
  EditOrganizationUnit,
  OrganizationUnit,
  OrganizationUnitProperties,
} from 'BrokerTsLib/src/dtos'
import { useCreateOrganizationUnit } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useState } from 'react'
import { useNavigate } from 'react-router'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { SidebarProvider } from '@/context/SidebarContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

import { OrganizationForm } from '../../containers/organization/OrganizationForm'

export const OrganizationCreatePage = () => {
  const navigate = useNavigate()
  const toast = useToast()

  const [organization] = useState({} as OrganizationUnit)
  const [properties] = useState({} as OrganizationUnitProperties)

  const { mutateAsync: create } = useCreateOrganizationUnit()

  const onSubmit = (values: EditOrganizationUnit) =>
    create(values)
      .then((response) => {
        navigate('/organization/' + response.data.id)

        return response.data
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při vytváření organizace',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e
      })

  return (
    <SidebarProvider>
      <PageWrapper
        header={
          <>
            <Breadcrumbs
              items={[
                { to: '/organization/list', label: 'Seznam organizací' },
                {
                  to: '/organization/create',
                  label: 'Vytvořit organizaci',
                  current: true,
                },
              ]}
            />
            <DashboardHeader sx={{ py: 16 }} title="Vytvořit organizaci" />
          </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
          },
        }}
      >
        <OrganizationForm
          organization={organization}
          properties={properties}
          onSubmit={onSubmit}
          isCreate
        />
      </PageWrapper>
    </SidebarProvider>
  )
}
